import React, { memo, forwardRef } from "react";
const SvgCapitalUpsilon = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M22.992 8.944l-5.664 7.896v6.192c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V16.84L9.336 9.064C9.112 8.744 9 8.44 9 8.152c0-.336.112-.608.336-.816.24-.224.536-.336.888-.336.432 0 .816.248 1.152.744l4.824 7.104 4.872-7.176c.304-.448.672-.672 1.104-.672.304 0 .568.104.792.312.224.192.336.448.336.768 0 .288-.104.576-.312.864z"
      />
    </svg>
  );
});
SvgCapitalUpsilon.displayName = "SvgCapitalUpsilon";
const MemoForwardRef = memo(SvgCapitalUpsilon);
export default MemoForwardRef;
